import { render, staticRenderFns } from "./gatherWater.vue?vue&type=template&id=6f97de1a&"
import script from "./gatherWater.vue?vue&type=script&lang=js&"
export * from "./gatherWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports